import React, { FC } from 'react'

import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp'
import { Controller, useFormContext } from 'react-hook-form'

import ErrorMessage from 'Components/ErrorMessage'

import FormErrors from '../../FormErrors'

import OtpInputSlots from './OtpInputSlots'

const OTP_LENGTH = 6

const sanitizeOtpValue = (value: string) => value.replace(/\D/g, '').slice(0, OTP_LENGTH)

const otpValidationRules = {
  required: false,
}

interface Props {
  canAutoSubmit: boolean
  codeInputRef: React.MutableRefObject<HTMLInputElement | null>
  handleResend: () => void
  handleSubmitCode: () => void
  resendSecondsLeft: number
}

const Code: FC<Props> = ({ canAutoSubmit, codeInputRef, handleResend, handleSubmitCode, resendSecondsLeft }) => {
  const { clearErrors, control, errors } = useFormContext()

  return (
    <div className="checkout-contact-flow__field-group">
      <div className="form-group mb-2">
        <label className="sr-only" htmlFor="customer-code">
          Verification code
        </label>
        <Controller
          control={control}
          name="code"
          render={({ name, onBlur, onChange, value }) => (
            <OTPInput
              ref={(element) => {
                codeInputRef.current = element
              }}
              autoComplete="one-time-code"
              className="checkout-otp-input__input"
              containerClassName="checkout-contact-flow__otp checkout-otp-input"
              id="customer-code"
              inputMode="numeric"
              maxLength={OTP_LENGTH}
              name={name}
              pattern={REGEXP_ONLY_DIGITS}
              render={({ slots }) => <OtpInputSlots slots={slots} />}
              spellCheck={false}
              type="text"
              value={value || ''}
              onBlur={onBlur}
              onChange={(newValue) => {
                clearErrors('code')
                onChange(sanitizeOtpValue(newValue))
              }}
              onComplete={() => {
                if (!canAutoSubmit) return
                handleSubmitCode()
              }}
            />
          )}
          rules={otpValidationRules}
        />
        <ErrorMessage as={FormErrors} errors={errors} name="code" />
      </div>
      <button className="checkout-button" disabled={resendSecondsLeft > 0} type="button" onClick={handleResend}>
        {resendSecondsLeft > 0 ? `Resend in - ${resendSecondsLeft} s` : 'Resend code'}
      </button>
    </div>
  )
}

export default Code
